/**
 * The partner category will be passed from the parameters
 */
const SERVER_URL = "/api/v2/products/:partnerCategory";

export default {
  //partner management
  getPartnerProductList: {
    method: "get",
    url: `${SERVER_URL}/internal/products/partner/list`,
  },
  getPartnerProductDetail: {
    method: "get",
    url: `${SERVER_URL}/internal/products/partner/detail/:id`,
  },
  addPartnerProduct: {
    method: "post",
    url: `${SERVER_URL}/products/partner`,
  },
  updatePartnerProduct: {
    method: "patch",
    url: `${SERVER_URL}/internal/products/partner/:product_code`,
  },
  deletePartnerProduct: {
    method: "delete",
    url: `${SERVER_URL}/internal/products/partner/:product_code`,
  },

  // Partner associated brokers (org-scoped)
  associatedBrokers: {
    method: "get",
    url: "/user/v1/v2/partners/:code/brokers",
  },
  associateBrokers: {
    method: "patch",
    url: "/user/v1/v2/partners/:code/associate-brokers",
  },
  deleteAssociatedBrokers: {
    method: "delete",
    url: "/user/v1/v2/partners/:code/brokers/:brokerCode",
  },
};
